module.exports = __webpack_public_path__ + "static/media/help.c3ad632e.svg";